export default "__VITE_ASSET__4f326c77__"